import Button from 'components/atoms/Button/Button';
import TextFormField from 'components/molecules/TextFormField/TextFormField';
import { FC, useState } from 'react';
import useUserStyle from '../../UserStyle';

interface IFreeTextSearchUsers {
  setSearchText: (searchText: string) => void;
  initialValue: string;
}

const FreeTextSearchUsers: FC<IFreeTextSearchUsers> = ({
  setSearchText,
  initialValue,
}) => {
  const [search, setSearch] = useState<string>(initialValue);
  const classes = useUserStyle();

  const handleChange = (value: string) => {
    setSearch(value);
  };

  const handleSearch = () => {
    setSearchText(search);
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: 600,
        marginBottom: 30,
        marginTop: 30,
        alignItems: 'center',
        gap: 10,
      }}
    >
      <TextFormField
        id="id"
        name="id"
        label="free text search"
        value={search}
        onChange={handleChange}
        className={classes.mr10}
      />
      <Button onClick={handleSearch}>Search</Button>
    </div>
  );
};

export default FreeTextSearchUsers;
